<button
    [type]="type"
    [class]="'btn btn-' + variant"
    [disabled]="disabled"
    (click)="onClick($event)"
>
    {{ label | translate }}
    <ng-content></ng-content>
</button>
